import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://api-daily.porters-dev.win/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email, password) =>
    api.post('/auth/login', { email, password }),
  logout: () =>
    api.post('/auth/logout', {}),
  changePassword: (currentPassword, newPassword, confirmPassword) =>
    api.post('/auth/change-password', { currentPassword, newPassword, confirmPassword }),
  getCurrentUser: () =>
    api.get('/auth/me')
};

export const reportAPI = {
  submitReport: (yesterdayText, todayText) =>
    api.post('/reports/submit', { yesterdayText, todayText }),
  getReport: (date) =>
    api.get('/reports/get', { params: { date } }),
  getTeamStatus: (date) =>
    api.get('/reports/team-status', { params: { date } }),
  getTodayDate: () =>
    api.get('/reports/today-date'),
  getAuditTrail: (reportId) =>
    api.get(`/reports/${reportId}/audit`)
};

export const leaderAPI = {
  getTeamReports: (date, teamId) =>
    api.get('/leader/team-reports', { params: { date, teamId } }),
  getMemberHistory: (memberId, days) =>
    api.get(`/leader/member-history/${memberId}`, { params: { days } }),
  getAllTeams: () =>
    api.get('/leader/teams'),
  getAvailableDates: (year, month, teamId) =>
    api.get('/leader/available-dates', { params: { year, month, teamId } })
};

export const summaryAPI = {
  preview: (date, teamId) =>
    api.get('/summary/preview', { params: { date, teamId } }),
  send: (date, teamId, confirmOffline = false) =>
    api.post('/summary/send', { date, teamId, confirmOffline }),
  status: (date, teamId) =>
    api.get('/summary/status', { params: { date, teamId } }),
  history: (teamId, limit) =>
    api.get('/summary/history', { params: { teamId, limit } })
};

export const notificationAPI = {
  getHistory: (teamId, limit) =>
    api.get('/notifications/history', { params: { teamId, limit } }),
  sendReminders: () =>
    api.post('/notifications/send-reminders', {}),
  triggerDailyCheck: () =>
    api.post('/notifications/trigger-daily-check', {}),
  getSchedulerStatus: () =>
    api.get('/notifications/scheduler-status')
};

export default api;
